import { ButtonHTMLAttributes, forwardRef } from 'react'
import { cn } from '../../lib/utils'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost'
  size?: 'sm' | 'md' | 'lg'
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'primary', size = 'md', children, ...props }, ref) => {
    const getVariantStyles = () => {
      switch (variant) {
        case 'primary':
          return {
            className: 'shadow-lg font-bold',
            style: { 
              backgroundColor: '#2e7d32', 
              color: '#ffffff',
              border: 'none'
            }
          }
        case 'secondary':
          return {
            className: 'bg-gray-200 hover:bg-gray-300 text-gray-900',
            style: {}
          }
        case 'outline':
          return {
            className: 'hover:bg-primary-50',
            style: { 
              border: '2px solid #2e7d32', 
              color: '#2e7d32',
              backgroundColor: 'transparent'
            }
          }
        case 'ghost':
          return {
            className: 'hover:bg-gray-100 text-gray-700',
            style: {}
          }
        default:
          return { className: '', style: {} }
      }
    }

    const sizes = {
      sm: 'px-4 py-2 text-sm',
      md: 'px-6 py-3 text-base',
      lg: 'px-8 py-4 text-lg',
    }

    const variantStyles = getVariantStyles()

    return (
      <button
        ref={ref}
        className={cn(
          'inline-flex items-center justify-center rounded-lg font-semibold transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed',
          variantStyles.className,
          sizes[size],
          className
        )}
        style={variantStyles.style}
        {...props}
      >
        {children}
      </button>
    )
  }
)

Button.displayName = 'Button'

export default Button
